import React, { Component } from "react";

import BackHeader from "../../components/BackHeader";

class BorRequests extends Component {
  backToMenu() {
    this.props.history.goBack();
  }

  render() {
    return (
      <div>
        <BackHeader text="Reference Tools" onClick={() => this.backToMenu()} />
        <h1 className="mb-5">BOR Requests</h1>
        <div className="bor-label">
          <span className="bor-header">Agent/Broker of Record Process</span>
          <div className="bor-content">
            <span className="bor-subheader">
              What is an Agent of Record letter (AOR) or Broker of Record letter
              (BOR)?
            </span>
            <p>
              An Agent or Broker of Record letter, or AOR/BOR, is a written
              statement by a named insured designating the specific insurance
              agency or broker that they want to represent them with a carrier
              or carriers. Once the AOR/BOR is processed, this allows the
              designated agent or broker to become the “agent of record” or
              “broker of record” and discuss and/or service the insured’s
              policies.
            </p>
            <span className="bor-subheader">Important Considerations</span>
            <ul>
              <li>
                10 Day Waiting (Rescind) Period:
                <br />
                <span>
                  AOR/BOR changes must follow a very specific process with
                  appropriate lead time. Once an AOR/BOR is requested, there is
                  a 10 day wait time before our carriers will process the
                  AOR/BOR and reassign the policies to the requesting
                  agent/broker, Ivantage.
                </span>
              </li>
              <li>
                Changes Only at Renewal:
                <br />
                <span>
                  AOR/BOR changes are processed only at renewal. No AOR or BOR
                  changes are processed mid-term, regardless of the line of
                  business. See carrier specifics for submissions.
                </span>
              </li>
            </ul>
          </div>

          <span className="bor-header">
            For Policies Written Through Ivantage Markets
          </span>
          <div className="bor-content">
            <ol>
              <li>
                Obtain a written request from the insured requesting that their
                policy(ies) be reassigned to Ivantage/Northeast Agencies Inc.
                The letter must:
                <ul>
                  <li>
                    Be on Insured’s letterhead and addressed to the carrier.
                    (CBIC will take the Acord)
                  </li>
                  <li>
                    Be signed and dated by the owner/officer of the named
                    insured.
                  </li>
                  <li>
                    Include the owner/officer’s title (owner, president, etc.).
                  </li>
                  <li>
                    Specifically list all policies to include policy number,
                    renewal date and LOB.
                  </li>
                  <li>
                    Request that they be represented by Ivantage/Northeast
                    Agencies Inc., effective the renewal date.
                  </li>
                </ul>
              </li>
              <li>
                Submit the AOR/BOR to Ivantage Commercial Lines (NEA) via email
                or fax.
              </li>
            </ol>
          </div>
          <i>Some carriers will accept the Acord form</i>
        </div>
      </div>
    );
  }
}

export default BorRequests;
